<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="姓名" property="name">
									<el-input
										v-model="searchForm.name"
										placeholder="请输入姓名"
										clearable
										@keyup.enter.native="get_student"
									>
									</el-input>
								</el-form-item>
								<el-form-item label="工号" property="code">
									<el-input
										v-model="searchForm.code"
										placeholder="请输入工号"
										clearable
										@keyup.enter.native="get_student"
									>
									</el-input>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
								<el-button size="mini" type="primary" @click.native.prevent="get_student">查 询</el-button>
								<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<hr class="search_border">
						<div class="search_tools_div">
						<div class="search_tools_text">数据列表</div>
						<div class="search-tools">
							<el-button size="mini" type="primary" @click.native.prevent="add_student">新 增</el-button>
							<!-- <el-button type="primary" @click="exportExcel">导出</el-button> -->
						</div>
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					  @selection-change="handleSelectionChange">
						<!-- <el-table-column type="selection" width="50" align="center"></el-table-column> -->
						<el-table-column type="index" width="80" align="center" label="序号"></el-table-column>
						<el-table-column prop="personName" label="姓名" show-overflow-tooltip align="center"></el-table-column>
						<el-table-column prop="personNo" label="工号" align="center"></el-table-column>
						<el-table-column prop="personSex" label="性别" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								<el-tag type="primary" v-if="scope.row.personSex == 1">男</el-tag>
								<el-tag type="success" v-if="scope.row.personSex == 0">女</el-tag>
								<el-tag type="warning" v-if="scope.row.personSex == 2">未知</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="identityId" label="类型" show-overflow-tooltip align="center">
							<template slot-scope="scope">
								<el-tag type="primary" v-if="scope.row.identityId == 1">教职工</el-tag>
								<el-tag type="success" v-if="scope.row.identityId == 2">学生</el-tag>
								<el-tag type="warning" v-if="scope.row.identityId == 3">临时人员</el-tag>
							</template>
						</el-table-column>
						<el-table-column label="操作" sortable align="center">
							<template slot-scope="scope">
								<el-button style="margin-right: 10px;" type="text" v-if="hasAuth('base:person:update')" @click="editHandle(scope.row)">编辑</el-button>
								<el-popconfirm title="确定删除该人员信息吗？" v-if="hasAuth('base:person:delete')" @confirm="delHandle(scope.row)">
									<el-button type="text" slot="reference">删除</el-button>
								</el-popconfirm>
							</template>
						</el-table-column>

					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--新增对话框-->
		<el-dialog
		  :title="title"
		  :visible.sync="dialogVisible"
		  width="700px"
		  :before-close="handleClose"
		  :close-on-click-modal="false">
			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">

				<el-form-item label="姓名" prop="personName">
					<el-input v-model="editForm.personName" placeholder="请输入姓名" type="text" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="工号" prop="personNo">
					<el-input v-model="editForm.personNo" placeholder="请输入工号" type="text" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="personSex">
					<el-select v-model="editForm.personSex" placeholder="请选择性别">
						<el-option :value="1" label="男"></el-option>
						<el-option :value="0" label="女"></el-option>
						<el-option :value="2" label="未知"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="类型" prop="identityId">
					<el-select v-model="editForm.identityId" placeholder="请选择类型">
						<el-option :value="1" label="教职工"></el-option>
						<!-- <el-option :value="2" label="学生"></el-option> -->
						<!-- <el-option :value="3" label="临时人员"></el-option> -->
					</el-select>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { listBase, getPersonOnce, addStudent, updateStudent, delStudent } from '@/apis/student'
export default {
	name: "Student",	// 人员列表管理
	data() {
		return {
			nowDate: '',
			loading: true,

			searchForm: {},
			delBtlStatu: true,

			total: 0,
			size: 10,
			current: 1,

			dialogVisible: false,
			title: '新增人员',
			identArr: [
				{value: 1, label: '教职工'},
				// {value: 2, label: '人员'},
				// {value: 3, label: '临时人员'},
			],
			editForm: {},

			tableData: [],

			editFormRules: {
				personName: [
					{required: true, message: '请输入人员姓名', trigger: 'blur'}
				],
				personNo: [
					{required: true, message: '请输入工号', trigger: 'blur'}
				],
				personSex: [
					{required: true, message: '请选择性别', trigger: 'blur'}
				],
				identityId: [
					{required: true, message: '请选择身份类型', trigger: 'blur'}
				],
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		this.get_student()
		let t = new Date()
		let end = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + t.getDate()
		this.nowDate = end
	},
	methods: {
		getExcel(excelData) {
            var XLSX = require("xlsx");

            // 创建一个工作表
            const worksheet = XLSX.utils.json_to_sheet(excelData)
            // 创建一个新的工作簿
            const workbook = XLSX.utils.book_new()

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
            // 改写表头   'sku', 'wlms', 'ddsl', 'shsl', 'jhy'
            XLSX.utils.sheet_add_aoa(worksheet, [['序号', '区域', '房间', '姓名', '工号', '类型', '成员类型', '入住时间']], { origin: 'A1' })
            XLSX.writeFileXLSX(workbook, `人员列表${this.nowDate}.xlsx`)
        },
		resetSearchForm() {
			this.current = 1
			this.searchForm = {}
			this.get_student()
		},
		adjustCascaderData(data) {
			return data.map(item => {
				if (item.children && item.children.length == 0) {
					delete item.children; // 删除空的 children 数组
				} else {
					item.children = this.adjustCascaderData(item.children);
				}
				return item;
			});
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;

			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			this.size = val
			this.get_student()
		},
		handleCurrentChange(val) {
			this.current = val
			this.get_student()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},
		get_student() {
			listBase({current: this.current, size: this.size, ...this.searchForm}).then(res => res.data).then(res => {
				this.tableData = res.data.records
				this.total = res.data.total
				this.loading = false
			})
		},
		add_student() {
			this.title = '新增人员'
			this.dialogVisible = true
			this.editForm = {}
		},
		editHandle(row) {
			this.title = '编辑人员信息'
			getPersonOnce(row.id).then(res => res.data).then(res => {
				this.editForm = res.data
				this.dialogVisible = true
			})
		},
		delHandle(row) {
			delStudent(row.id).then(res => res.data).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
					})
					this.get_student()
				}
			})
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.editForm.id) {
						updateStudent(this.editForm).then(res => res.data).then(res => {
							// console.log(res);
							
							if (res.code == 200) {
								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
								})
								this.dialogVisible = false
								this.get_student()
							}
						})
					} else {
						addStudent({...this.editForm, deptId: this.editForm.identityId == 2 ? 3 : this.editForm.identityId == 3 ? 4 : 2}).then(res => res.data).then(res => {
						// addStudent({...this.editForm, deptId: this.editForm.identityId == 3 ? 4 : 3}).then(res => res.data).then(res => {
							// console.log(res);
							if (res.code == 200) {
								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
								})
								this.dialogVisible = false
								this.get_student()
							}
						})
					}
				} else {
					// console.log('error submit!!');
					return false;
				}
			});
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

</style>